var _path, _rect, _rect2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReverse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "09_\u51B2\u6B63") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.78,27.45h0a2,2,0,0,1,0-2.83l19.86-20a2,2,0,0,1,2.81,0h0a2,2,0,0,1,0,2.83l-19.86,20A2,2,0,0,1,32.78,27.45Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 43.96,
    width: 28.11,
    height: 4,
    rx: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 32,
    width: 19.99,
    height: 4,
    rx: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52,60H12a4,4,0,0,1-4-4V8a4,4,0,0,1,4-4H38.65a2,2,0,0,1,0,4H12V56H52V21.52a2,2,0,1,1,4,0V56A4,4,0,0,1,52,60Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReverse);
export default __webpack_public_path__ + "static/media/reverse.7537d866.svg";
export { ForwardRef as ReactComponent };